import { DEFAULT_STRAPI_STALE_TIME } from '@betterpool/strapi-client';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { LocationContext } from '~/components/providers/LocationProvider';
import { locationStorage } from '~/utils/locationStorage';

import getPromoContests from './getPromoContests';

export const usePromoContests = () => {
  const { locationCountryNameSafe } = useContext(LocationContext);

  const effectiveLocation =
    locationCountryNameSafe ?? locationStorage.getBestAvailableLocationCountry();

  return useQuery({
    queryKey: ['cms@promoContests', effectiveLocation],
    queryFn: () => getPromoContests(effectiveLocation),
    staleTime: DEFAULT_STRAPI_STALE_TIME,
  });
};
